import React, { Component } from 'react';
import './Select.css';
import ReactSelect from 'react-select';
import { loadVacancies } from '../../actions/VacanciesActions';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

class Custom extends Component {
  handleMouseDown = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.props.onSelect(this.props.option, event);
  }
  handleMouseEnter = (event) => {
    this.props.onFocus(this.props.option, event);
  }
  handleMouseMove = (event) => {
    if (this.props.isFocused) return;
    this.props.onFocus(this.props.option, event);
  }
  render () {
    return (
      <div className={this.props.className}
        onMouseDown={this.handleMouseDown}
        onMouseEnter={this.handleMouseEnter}
        onMouseMove={this.handleMouseMove}
        >
        <div className="Select-optionName">{this.props.children}</div>
        {
          this.props.option.amount && <span className="Select-optionLength">{this.props.option.amount}</span>
        }
      </div>
    );
  }
};

class Select extends Component {
  state = {
    selectedOption: '',
  }

  handleChange = (selectedOption) => {
    this.setState({ selectedOption });
    if (this.props.changeOption) {
      const val = selectedOption.value;
      const label = selectedOption.label;
      const type = this.props.type;
      this.props.changeOption(val, label, type);
    }
  }
  render() {
    const options =
      this.props.alphabeticSort ?
      this.props.options.sort((a, b) => {
        if (!a.value || !b.value) {
          return 0;
        } else {
          return a.label.localeCompare(b.label, 'en');
        }
      }) :
      this.props.options;

    const { selectedOption } = this.state;
    const value = (selectedOption && selectedOption.value) || ((this.props.value && (this.props.value.id && this.props.value.label !== "")) && this.props.value);

    return (
      <ReactSelect
        name={this.props.name}
        value={value}
        onChange={this.handleChange}
        options={options}
        optionComponent={Custom}
        placeholder={this.props.placeholder}
        clearable={false}
        searchable={false}
        className={`${this.props.modifier ? this.props.modifier : ''} ${this.props.required && selectedOption === '' ? ' Select--required' : ''}`}
        scrollMenuIntoView={false}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    filter: state.filter,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({ loadVacancies }, dispatch)
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Select));



// WEBPACK FOOTER //
// ./src/components/Select/index.js